import ConnectionList from "../ConnectionList";
import { useLazyGetFollowersQuery } from "features/community/apis";

const Followers = () => {
  const [trigger, { isFetching }] = useLazyGetFollowersQuery();
  return (
    <ConnectionList title="Followers" trigger={trigger} isFetching={isFetching} listType="followers" />
  );
};

export default Followers;
